import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

/**
 * Prepared to set line height by another class,
 * typically used for icons to be alliged to first line of text of given height
 *
 * does not work with long contents
 *
 * usage:
 * in the example below icon is set to within s1 class lineheight:
 *
 * <div lineHeightBy="s1"><i class="icon-plus"></i></div>
 */
@Component({
    standalone: true,
    imports: [NgClass],
    selector: '[lineHeightBy]',
    template: `
        <div class="inline-block va-m" style="width:0" [ngClass]="lineHeightBy">&nbsp;</div>
        <div class="inline-block va-m target-el">
            <div class="inline-block target-el-in vc-outer flex flex-middle">
                <ng-content />
            </div>
        </div>
    `,
    styles: [
        `
            :host {
                display: inline-block;
                vertical-align: top;
                position: relative;
            }
            .target-el {
                height: 0;
            }
            .target-el-in {
                transform: translateY(-50%);
            }
        `
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LineHeightByComponent {
    /**
     * Line height class name
     */
    @Input()
    lineHeightBy!: string;
}
